import React from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import profileIcon from "../../../../../assets/icons/profile-3.svg";
import { Row, Col } from "antd";
import {
  SubHeadTitle,
  ImageWrap,
  KeyStyle,
  ValueStyle,
  PhoneInfoWrapMain,
  PhoneInfoWrap,
  AdressInfoWrap
} from "./Details/styles";
import { filterDataWithValue } from "../../Data/FilterDropDownData";
import { basicInfo, basicImports } from '../../DefaultPropTypes';

export const RelatedContributor = props => {
  const getValues = value => {
    let val = filterDataWithValue(value, props.relationshipDropdown);
    return val[0].desc;
  };
  return (
    <div>
      <Row>
        {props.relatedContributorInfo && 
          props.relatedContributorInfo[0].relatedDonor.length != 0 && (
          <Col lg={{ span: 10 }} md={{ span: 10 }}>
          <SubHeadTitle paddingTop="20px">
            <ImageWrap marginRight="10px" src={profileIcon} alt="Profile" />
            Related Contributor
          </SubHeadTitle>
            {props.relatedContributorInfo[0].relatedDonor.map((val,iteration) => (
              <PhoneInfoWrapMain key={iteration+1}>
                <AdressInfoWrap>
                  <div>
                    <ValueStyle lineHeight="2">{val.name}</ValueStyle>
                  </div>
                  <KeyStyle lineHeight="2">Relation:</KeyStyle>&nbsp;
                  <ValueStyle lineHeight="2">
                    {val.relationship != "" ?  getValues(val.relationship) : <>&mdash;</>}
                  </ValueStyle>
                </AdressInfoWrap>
              </PhoneInfoWrapMain>
            ))}
        </Col>
        )}
      </Row>
    </div>
  );
};

const mapStateToProps = state => ({
  relatedContributorInfo: state.getIn([
    "npaFormReducer",
    "tempJSON",
    "tempJSON",
    "tempJSON",
    "advisors"
  ]),
  relationshipDropdown: state.getIn([
    "npaFormReducer",
    "dropdownValues",
    "data",
    "relationship"
  ])
});

RelatedContributor.propTypes = {
  dispatch: PropTypes.func,
  relatedContributorInfo: PropTypes.arrayOf(basicInfo),
  relationshipDropdown: basicImports
}

export default connect(mapStateToProps)(RelatedContributor);
